export default {
    computed: {
        intercomOptions() {
            if (process.env.NODE_ENV !== 'production') return null
            return this.$user.isLoggedIn
                ? {
                      guest: false,
                      user_id: `${process.env.VUE_APP_INTERCOM}-${this.$user.model.id}`,
                      name: this.$user.model
                          ? `${this.$user.model.first_name} ${this.$user.model.last_name}`
                          : null,
                      email: this.$user.model.email,
                      company: this.$user.model?.company
                          ? {
                                company_id: this.$user.model.company.id,
                                name: this.$user.model.company.name,
                            }
                          : null,
                      phone: this.$user.model.phone,
                      created_at: this.$user.model.created_at,
                      'Budget Left':
                          this.$store.getters['expenseRules']
                              ?.map((x) => x.budget)
                              .reduce((total, budget) => total + budget, 0) || 0,
                      // 'Fresh Login': this.freshLogin,
                  }
                : {
                      guest: true,
                  }
        },
    },
    mounted() {
        if (process.env.NODE_ENV === 'production') {
            this.$watch(
                'intercom',
                (intercom) => {
                    this.$intercom?.update(intercom)
                },
                { deep: true }
            )
        }
    },

    methods: {
        boot() {
            if (process.env.NODE_ENV === 'production') {
                this.$intercom?.boot(this.intercomOptions)
                this.$intercom?.callIntercom('onHide', () => {
                    this.$router.replace({ ...this.$route, ...{ hash: '' } })
                })
            }
        },
    },
}
